import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactFax } from "@/lib/types";
import { omit } from "lodash";
import { baseContactRoute } from "./contact";

export function createContactFaxV1(
  data: Pick<ContactFax, "number" | "label" | "contactId"> &
    Partial<ContactFax>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactFax>>(`${baseContactRoute}/faxes`, data)
    .then((res) => res.data);
}

export function updateContactFaxV1(
  data: Pick<ContactFax, "contactId" | "id" | "dateModified"> &
    Partial<ContactFax>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<ContactFax>
    >(`${baseContactRoute}/faxes`, omit(data, "contactId"))
    .then((res) => res.data);
}

export function deleteContactFaxV1({ id }: { contactId: string; id: string }) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactFax>>(`${baseContactRoute}/faxes/${id}`)
    .then((res) => res.data);
}
